import {
	formatCompactNumber,
	formatDate,
	formatDateTime,
	formatDocumentSize,
	formatLongDate,
	formatMonth,
	formatNumber,
	formatShortDate,
	formatShortDateTime,
	formatSize,
	formatTime,
} from '@/utils/format';
import { formatRelativeTime } from '@/utils/formatRelativeTime';
import type { Language } from '@/utils/language';

const UTC_TIME_ZONE = 'UTC';

/** Форматтеры с зафиксированными языком и поясом */
export function createFormatters(locale: Language, timeZone: string) {
	return {
		formatDate: (epochMs: number | undefined | null, fallback?: string) =>
			formatDate(epochMs, locale, fallback, timeZone),
		formatUtcDate: (epochMs: number | undefined | null, fallback?: string) =>
			formatDate(epochMs, locale, fallback, UTC_TIME_ZONE),
		formatDay: (epochMs: number | undefined | null, seriesTimeZone = timeZone) =>
			formatShortDate(epochMs, locale, undefined, seriesTimeZone),
		formatLongDate: (epochMs: number | undefined | null, fallback?: string) =>
			formatLongDate(epochMs, locale, fallback, timeZone),
		formatDateTime: (epochMs: number | undefined | null, fallback?: string) =>
			formatDateTime(epochMs, locale, fallback, timeZone),
		formatShortDateTime: (epochMs: number | undefined | null, fallback?: string) =>
			formatShortDateTime(epochMs, locale, fallback, timeZone),
		formatTime: (epochMs: number | undefined | null, fallback?: string) =>
			formatTime(epochMs, locale, fallback, timeZone),
		formatMonth: (epochMs: number) => formatMonth(epochMs, locale, timeZone),
		formatRelativeTime: (
			epochMs: number | undefined | null,
			fallback?: string,
			style?: Intl.RelativeTimeFormatStyle,
		) => formatRelativeTime(epochMs, locale, fallback, timeZone, style),
		formatNumber: (value: number, options?: Intl.NumberFormatOptions) =>
			formatNumber(value, locale, options),
		formatCompactNumber: (value: number) => formatCompactNumber(value, locale),
		formatSize: (bytes: number) => formatSize(bytes, locale),
		formatDocumentSize: (bytes: number, fallback?: string) =>
			formatDocumentSize(bytes, locale, fallback),
	};
}

/** Форматтеры дат и чисел: язык интерфейса и пояс организации */
export type Formatters = ReturnType<typeof createFormatters>;
